/**
 * Generic carousel for landscape thumbnail ratio view
 *
 * eg.
 *
 * =============
 * DOM structures
 * =============
 *  <section class="js-le-carousel">
 *      <div class="carousel-content">
 *          <div id="carousel-mount-selector-here" class="carousel" data-slug="..."></div>
 *      </div>
 *  </section>
 *
 *
 * OR
 *
 * ==============
 * PHP object render
 * ==============
 *
 * CONTROLLER:
 *
 * $carousel = new Carousel();
 * $carousel->setId('carousel-mount-selector-here')->setSlug('...');
 *
 *
 * VIEW TEMPLATE:
 *
 * $carousel->render();
 * ==============
 *
 * import landscapeCarousel from "components/landscapeCarousel";
 *
 * landscapeCarousel({
 *     parentContainer: $('#carousel-mount-selector-here'),
 *     options: {
 *         endPoint: '...',
 *         params: {
 *             slug: '...',
 *             ...
 *         }
 *     }
 * };
 *
 *
 * `options` : this key is passing to JsCarousel, so please refer to the doc at `development/js/shared/JsCarousel.js`
 *
 */

import 'components/carousels/JsCarousel.js';
import { SwiperCarouselLandsCapeBreakpoints } from 'components/settings/BreakpointSettings';
import { formatDate } from '../helpers/dates';

export default function (customOptions = {}) {
    let wrapper = customOptions.parentContainer
        ? customOptions.parentContainer
        : $('.generic-carousel');

    let defaultOptions = {
        responsive: SwiperCarouselLandsCapeBreakpoints,
    };

    let endOptions = $.extend(defaultOptions, customOptions.options);

    wrapper.on('videoDataLoad', (e, result) => {
        result?.data?.forEach((item) => {
            if (customOptions.formatDate === false || !item.startDateISO) return;

            item.startDate = formatDate(item.startDateISO);
        });
    });

    wrapper.on('templateDidRender', () => {
        wrapper.removeClass('hidden--temp-height');
    });

    wrapper.JsCarousel(endOptions);
    return wrapper;
}
